import { defineMessages } from 'react-intl';

export default defineMessages({
  actionsOverflowLabel: {
    id: 'yield-management.schedule-detail-v2.actions.overflow-label',
    defaultMessage: 'More options',
  },
  addNSpots: {
    id: 'yield-management.schedule-detail-v2.actions.add-n-spots',
    defaultMessage: 'Add {recommendation, plural, one {# spot} other {# spots}}',
  },
  addSpot: {
    id: 'yield-management.schedule-detail-v2.actions.add-spot',
    defaultMessage: 'Add spot',
  },
  cancelAllFuture: {
    id: 'yield-management.schedule-detail-v2.actions.cancel-all-future',
    defaultMessage: 'Cancel all future instances of this class',
  },
  cancelClass: {
    id: 'yield-management.schedule-detail-v2.actions.cancel-class',
    defaultMessage: 'Cancel this class',
  },
  editClassDetails: {
    id: 'yield-management.schedule-detail-v2.actions.edit-class-details',
    defaultMessage: 'Edit class details',
  },
  editMenuLabel: {
    id: 'yield-management.schedule-detail-v2.actions.edit-menu-label',
    defaultMessage: 'Edit options',
  },
  editStaff: {
    id: 'yield-management.schedule-detail-v2.actions.edit-staff',
    defaultMessage: 'Edit staff',
  },
  emailClass: {
    id: 'yield-management.schedule-detail-v2.actions.email-class',
    defaultMessage: 'Email class',
  },
  emailMenuLabel: {
    id: 'yield-management.schedule-detail-v2.actions.email-menu-label',
    defaultMessage: 'Email options',
  },
  emailNewClients: {
    id: 'yield-management.schedule-detail-v2.actions.email-new-clients',
    defaultMessage: 'Email new clients ({count, number})',
  },
  allBookingsLabel: {
    id: 'yield-management.schedule-detail-v2.booking-overview.all-bookings-label',
    defaultMessage: 'All bookings',
  },
  allBookingsTitleIntegrated: {
    id: 'yield-management.schedule-detail-v2.all-bookings.title-integrated',
    defaultMessage: 'All bookings',
  },
  allBookingsTitleManual: {
    id: 'yield-management.schedule-detail-v2.all-bookings.title-manual',
    defaultMessage: 'ClassPass bookings',
  },
  bookingOverviewTitle: {
    id: 'yield-management.schedule-detail-v2.booking-overview.title',
    defaultMessage: 'Booking overview',
  },
  bookingsFraction: {
    id: 'yield-management.schedule-detail-v2.booking-overview.bookings-fraction',
    defaultMessage: '<span>{x, number}</span><muted>/{y, number}</muted>',
  },
  classPassBookingsFraction: {
    id: 'yield-management.schedule-detail-v2.booking-overview.classpass-bookings-fraction',
    defaultMessage: '<span>{x, number}</span><muted>/</muted><span>{y, number}</span>',
  },
  classPassBookingsLabel: {
    id: 'yield-management.schedule-detail-v2.booking-overview.classpass-bookings-label',
    defaultMessage: 'ClassPass bookings',
  },
  classPassBookingsPickerFraction: {
    id: 'yield-management.schedule-detail-v2.booking-overview.classpass-bookings-picker-fraction',
    defaultMessage: '<span>{x, number}</span><muted>/</muted>{picker}',
  },
  maxBookings: {
    id: 'yield-management.schedule-detail-v2.booking-overview.max-bookings',
    defaultMessage: 'Max bookings: {count, number}',
  },
  maxBookingsTooltipSmartspot: {
    id: 'yield-management.schedule-detail-v2.booking-overview.max-bookings-tooltip-smartspot',
    defaultMessage:
      'Max bookings is the number of spots SmartSpot has allocated to ClassPass for this class. It only limits ClassPass reservations, direct clients can always book any open spot.',
  },
  maxBookingsTooltipStandard: {
    id: 'yield-management.schedule-detail-v2.booking-overview.max-bookings-tooltip-standard',
    defaultMessage:
      'Max bookings is the number of ClassPass spots for this class. It only limits ClassPass reservations, direct clients can always book any open spot.',
  },
  maxBookingsUnavailable: {
    id: 'yield-management.schedule-detail-v2.booking-overview.max-bookings-unavailable',
    defaultMessage: 'Max bookings: N/A',
  },
  createCampaignBannerBody: {
    id: 'yield-management.schedule-detail-v2.create-campaign-banner.body',
    defaultMessage: 'On average, campaigns increase impressions to your page by +16% and double reservations.',
  },
  createCampaignBannerCta: {
    id: 'yield-management.schedule-detail-v2.create-campaign-banner.cta',
    defaultMessage: 'Create a campaign',
  },
  createCampaignBannerTitle: {
    id: 'yield-management.schedule-detail-v2.create-campaign-banner.title',
    defaultMessage: 'Create a campaign',
  },
  directBookingsBodyAtOrAbove: {
    id: 'yield-management.schedule-detail-v2.direct-bookings.body-at-or-above',
    defaultMessage:
      "Your direct bookings are tracking <b>at or above the usual pace</b> for this class, so SmartSpot <b>isn't opening extra ClassPass spots</b> right now. This protects spots for your direct members. If the pace of bookings changes, SmartSpot may adjust accordingly. To always ensure there are a certain amount of spots bookable to ClassPass members see <link>here</link>.",
  },
  directBookingsBodyBelow: {
    id: 'yield-management.schedule-detail-v2.direct-bookings.body-below',
    defaultMessage:
      "Your direct bookings are tracking <b>below their usual pace</b> for this class. As a result, SmartSpot has increased ClassPass's max bookings. SmartSpot will only do this when it expects spots to go unfilled directly. Your direct members can also book these spots. You can also release extra spots to ClassPass members before class start time <link>here</link>.",
  },
  directBookingsBodyError: {
    id: 'yield-management.schedule-detail-v2.direct-bookings.body-error',
    defaultMessage:
      "We couldn't load the direct bookings for this class right now. Please refresh the page to try again.",
  },
  directBookingsBodyNoHistory: {
    id: 'yield-management.schedule-detail-v2.direct-bookings.body-no-history',
    defaultMessage:
      "This class has <strong>no historical direct demand or historical data</strong> to compare to. SmartSpot will adjust ClassPass's max bookings based on real-time demand. If the pace of bookings changes, SmartSpot may adjust accordingly. To help drive further ClassPass bookings, consider creating a campaign <link>here</link>.",
  },
  directBookingsChartError: {
    id: 'yield-management.schedule-detail-v2.direct-bookings.chart-error',
    defaultMessage: 'Unable to load data visualization. Please refresh the page to try again.',
  },
  directBookingsClassCapacity: {
    id: 'yield-management.schedule-detail-v2.direct-bookings.class-capacity',
    defaultMessage: 'Class capacity: <value>{count, number}</value>',
  },
  directBookingsDaysBeforeClass: {
    id: 'yield-management.schedule-detail-v2.direct-bookings.days-before-class',
    defaultMessage: 'Days before class',
  },
  directBookingsDaysBeforeTick: {
    id: 'yield-management.schedule-detail-v2.direct-bookings.days-before-tick',
    defaultMessage: '{days, number}d',
  },
  directBookingsLegendCurrent: {
    id: 'yield-management.schedule-detail-v2.direct-bookings.legend-current',
    defaultMessage: 'Current',
  },
  directBookingsLegendLabel: {
    id: 'yield-management.schedule-detail-v2.direct-bookings.legend-label',
    defaultMessage: 'Direct bookings:',
  },
  directBookingsLegendPastAvg: {
    id: 'yield-management.schedule-detail-v2.direct-bookings.legend-past-avg',
    defaultMessage: 'Past 4 wk avg',
  },
  directBookingsLegendPrediction: {
    id: 'yield-management.schedule-detail-v2.direct-bookings.legend-prediction',
    defaultMessage: 'Prediction',
  },
  directBookingsManageSmartSpot: {
    id: 'yield-management.schedule-detail-v2.direct-bookings.manage-smartspot',
    defaultMessage: 'Manage SmartSpot',
  },
  directBookingsPredictionTooltip: {
    id: 'yield-management.schedule-detail-v2.direct-bookings.prediction-tooltip',
    defaultMessage:
      'An estimate of your final direct fill, based on current bookings, demand, and past booking patterns.',
  },
  directBookingsTitle: {
    id: 'yield-management.schedule-detail-v2.direct-bookings.title',
    defaultMessage: 'Direct bookings for this class, compared to recent booking history',
  },
  directBookingsToday: {
    id: 'yield-management.schedule-detail-v2.direct-bookings.today',
    defaultMessage: 'Today',
  },
  lastWeekFill: {
    id: 'yield-management.schedule-detail-v2.all-bookings.last-week-fill',
    defaultMessage: "Last week's final fill: <value>{filled, number}/{capacity, number}</value>",
  },
  legendClasspass: {
    id: 'yield-management.schedule-detail-v2.all-bookings.legend-classpass',
    defaultMessage: 'ClassPass {count}',
  },
  legendDirect: {
    id: 'yield-management.schedule-detail-v2.all-bookings.legend-direct',
    defaultMessage: 'Direct {count}',
  },
  legendOpenSpots: {
    id: 'yield-management.schedule-detail-v2.all-bookings.legend-open-spots',
    defaultMessage: 'Open spots {count}',
  },
  viewMoreInsights: {
    id: 'yield-management.schedule-detail-v2.all-bookings.view-more-insights',
    defaultMessage: 'View more insights',
  },
  date: {
    id: 'yield-management.insights.historical-utilization-table.date',
    defaultMessage: 'Date',
  },
  earned: {
    id: 'yield-management.insights.historical-utilization-table.earned',
    defaultMessage: 'Earned',
  },
  emptyUtilization: {
    id: 'components.pill-graph',
    defaultMessage: 'No open spots or reservations',
  },
  legendClasspassBookings: {
    id: 'yield-management.schedule-detail-v2.historical-utilization.legend-classpass-bookings',
    defaultMessage: 'ClassPass bookings',
  },
  legendClasspassOnly: {
    id: 'yield-management.schedule-detail-v2.historical-utilization.legend-classpass',
    defaultMessage: 'ClassPass',
  },
  legendDirectOnly: {
    id: 'yield-management.schedule-detail-v2.historical-utilization.legend-direct',
    defaultMessage: 'Direct',
  },
  legendUnfilled: {
    id: 'yield-management.schedule-detail-v2.historical-utilization.legend-unfilled',
    defaultMessage: 'Unfilled',
  },
  summary: {
    id: 'yield-management.insights.historical-utilization.summary',
    defaultMessage:
      'Take a look at the performance of {className} at {startDateTime, date, time} for the past {weeksCount, plural, one {week} other {# weeks}}.',
  },
  title: {
    id: 'yield-management.schedule-detail-v2.historical-utilization.title',
    defaultMessage: 'Historical utilization',
  },
  tooltipClasspass: {
    id: 'yield-management.schedule-detail-v2.historical-utilization.tooltip-classpass',
    defaultMessage: '{count, number} ClassPass',
  },
  tooltipDirect: {
    id: 'yield-management.schedule-detail-v2.historical-utilization.tooltip-direct',
    defaultMessage: '{count, number} Direct',
  },
  tooltipUnfilled: {
    id: 'yield-management.schedule-detail-v2.historical-utilization.tooltip-unfilled',
    defaultMessage: '{count, number} Unfilled',
  },
  utilization: {
    id: 'yield-management.insights.historical-utilization-table.utilization',
    defaultMessage: 'Utilization',
  },
  viewOtherClasses: {
    id: 'yield-management.schedule-detail-v2.historical-utilization.view-other-classes',
    defaultMessage: 'View other classes',
  },
  noInstructor: {
    id: 'yield-management.schedule-detail-v2.header.no-instructor',
    defaultMessage: 'No instructor specified',
  },
  ratingCount: {
    id: 'yield-management.schedule-detail-v2.header.rating-count',
    defaultMessage: '({count, number})',
  },
  tabInsights: {
    id: 'yield-management.schedule-detail-v2.tab.insights',
    defaultMessage: 'Insights',
  },
  tabRoster: {
    id: 'yield-management.schedule-detail-v2.tab.roster',
    defaultMessage: 'Roster',
  },
  rosterErrorTitle: {
    id: 'yield-management.schedule-detail-v2.roster-error.title',
    defaultMessage: 'The roster couldn’t be loaded.',
  },
  rosterErrorSubtitle: {
    id: 'yield-management.schedule-detail-v2.roster-error.subtitle',
    defaultMessage: 'Refresh the page to try again.',
  },
  timeDurationAndInstructor: {
    id: 'yield-management.schedule-detail-v2.header.time-duration-and-instructor',
    defaultMessage: '{startDateTime, date, time} ({duration, number} min) · {instructorName}',
  },
});
